import { render, staticRenderFns } from "./StartupsActivityList.vue?vue&type=template&id=67afcb09&scoped=true&"
import script from "./StartupsActivityList.vue?vue&type=script&lang=js&"
export * from "./StartupsActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67afcb09",
  null
  
)

export default component.exports